import * as React from "react";
import {UIState} from "data/UIState";

export const PlatformClosed = () =>
  <>
    <p>Platform Closed on {UIState.settings.PLATFORM_CLOSED_DATE}.</p>
  </>
;
